/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSelector } from 'reselect'
import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'
import {
  getAllGroupsPermissionsStructure,
  getLocalPermissions,
} from 'src/utils/permissions'
import deepMerge from 'deepmerge'
import { AppView } from 'src/services/session'

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX].data

export const connectedAccounts = (
  state: TGlobalStateWithService
): IState['accounts'] => state[PREFIX].accounts

export const allUsersSelector = (
  state: TGlobalStateWithService
): IState['allUsers'] => state[PREFIX].allUsers

export const oauthClientsSelector = (
  state: TGlobalStateWithService
): IState['data']['oauthClients'] => state[PREFIX].data.oauthClients

export const userWithSearchSelector = (
  state: TGlobalStateWithService
): IState['allUsers'] => state[PREFIX].usersWithSearch

export const rolesSelector = (
  state: TGlobalStateWithService
): IState['roles'] => state[PREFIX].roles

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

const selectUser = createSelector(selectData, (state) => state.user)

export const selectors = {
  partnerData: createSelector(selectData, (state) => state.partnerData),
  isAfterLogin: createSelector(selectData, (state) =>
    Boolean(state.isAfterLogin)
  ),

  isUpdatePermissions: createSelector(selectData, (state) =>
    Boolean(state.isUpdatePermissions)
  ),
  isGuest: createSelector(selectData, (state) => !Boolean(state.accessToken)),
  isUser: createSelector(selectData, (state) => Boolean(state.accessToken)),
  userId: createSelector(selectData, (state) => state.user?.id || state.userId),
  isAdmin: createSelector(selectUser, (user) =>
    Boolean(user?.groups.find((group) => group.slug === 'admin'))
  ),

  permissions: createSelector(selectUser, (user) => {
    const permissions = getAllGroupsPermissionsStructure(
      user?.enabledPermissionsSlugs || []
    )

    const localPermissions = getLocalPermissions()

    return deepMerge(localPermissions, permissions)
  }),

  roles: createSelector(rolesSelector, (state) => state),

  user: createSelector(selectData, (state) => state.user),
  userData: createSelector(selectData, (state) => state),
  allUsersSelector: createSelector(allUsersSelector, (state) => state),
  userWithSearchSelector: createSelector(
    userWithSearchSelector,
    (state) => state
  ),
  isMobileWebView: createSelector(
    selectData,
    (state) => state.appView === AppView.MOBILE
  ),
  oauthClientsSelector: createSelector(oauthClientsSelector, (state) => state),

  //TO DO ETO KOSTIL'
  targetedAccount: createSelector(connectedAccounts, (state) => state),
  billingStat: createSelector(selectData, (state) => state.billingStat),
}
